function Fruit() {
  const fruits = ["Apple", "Banana", "Cherry", "Date", "Elderberry"];
  return (
      <ul
        style={{
          backgroundColor: "#f0f8ff",
          padding: "20px",
          margin: "20px auto",
          listStyleType: "square",
          borderRadius: "8px",
          width: "200px",
        }}
      >
        {fruits.map((fruit, index) => (
          <li key={index} style={{ margin: "8px 0", fontSize: "16px" }}>
            {fruit}
          </li>
        ))}
      </ul>
  );
}

export default Fruit;
